import React from "react";
import { Modal, Button, } from "tea-component";
import {useIntl} from "umi";

import './index.scss';

export interface ConfirmModalProps {
  visible?: Boolean;
  onClick?: Function;
  onClose?: Function;
  title?: String;
  desc?: String;
  name?: String;
}

export default function ConfirmModal(props: ConfirmModalProps) {
  const { visible = false, onClick, onClose, title, desc, name } = props
  const { formatMessage } = useIntl();

  return (
    <>
      <Modal className='dbd-subscribepopbox' visible={visible} onClose={onClose}>
        <Modal.Body>
          <div className='dbd-subscribepopbox-cont'>
          <div className='dbd-subscribepopbox-cont-title'>{title}</div>
            <span className='dbd-subscribepopbox-cont-text'>{desc}</span>
            {
              name && <span className='dbd-subscribepopbox-cont-txt'>【{name}】?</span>
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="primary" onClick={onClick}>
            {formatMessage({id: "common_confirm"})}
          </Button>
          <Button type="weak" onClick={onClose}>
            {formatMessage({id: "common_cancel"})}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
